import { Model } from "./Model";
import { ResourceType } from "../enums/ResourceType";

export interface Resource extends Model {
	generalMessage: boolean;
	name: string;
	resourceType: ResourceType;
	resourceUrl: string;
	sortOrder: number;
}

export class Resource implements Resource {

	sortOrder = 0;

	constructor(data?: Partial<Resource>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}